import PublicAgreementPage, { TYPE_IDS } from "./PublicAgreementPage";

export default function Privacy() {
  return (
    <PublicAgreementPage
      typeId={TYPE_IDS.PrivacyPolicy}
      fallbackTitle="Privacy Policy"
      fallbackLead="This policy describes how CareerMaster collects, uses, and protects your information when you use our platform and optional SMS alerts."
    />
  );
}
